var map = {
	"./adminprofile/list": [
		1904,
		20
	],
	"./agentprofile/list": [
		1905,
		23
	],
	"./ai_assistant/list": [
		1906,
		26
	],
	"./api_key/list": [
		1907,
		29
	],
	"./canned_answer/list": [
		1908,
		34
	],
	"./chat_configuration/list": [
		2073,
		4
	],
	"./client/list": [
		1909,
		37
	],
	"./destination_restrictor/list": [
		1910,
		39
	],
	"./disposition/list": [
		1911,
		42
	],
	"./field/list": [
		1912,
		45
	],
	"./form/list": [
		1913,
		48
	],
	"./form_website/list": [
		1914,
		51
	],
	"./gdpr/list": [
		1915,
		53
	],
	"./invoice/list": [
		1916,
		55
	],
	"./journey/list": [
		1917,
		61
	],
	"./journey_draft/list": [
		1918,
		64
	],
	"./journey_trigger/list": [
		1919,
		65
	],
	"./journey_variable/list": [
		1920,
		68
	],
	"./list/list": [
		1921,
		71
	],
	"./list_file/list": [
		1922,
		74
	],
	"./mail_account/list": [
		1923,
		77
	],
	"./operational_hours/list": [
		1924,
		80
	],
	"./organization/list": [
		1925,
		83
	],
	"./pause/list": [
		1926,
		86
	],
	"./phonenumber_monthly_cost/list": [
		1927,
		89
	],
	"./phonenumber_monthly_cost_parent/list": [
		1928,
		92
	],
	"./phonenumber_purchase/list": [
		1929,
		96
	],
	"./phonenumber_setup_cost/list": [
		1930,
		99
	],
	"./phonenumber_setup_cost_parent/list": [
		1931,
		102
	],
	"./points_system/list": [
		1932,
		106
	],
	"./prepaid_credit/list": [
		1933,
		109
	],
	"./queue/list": [
		1934,
		112
	],
	"./release/list": [
		1935,
		113
	],
	"./signature/list": [
		1936,
		116
	],
	"./skill/list": [
		1937,
		119
	],
	"./sla_policy/list": [
		1938,
		122
	],
	"./sound/list": [
		1939,
		125
	],
	"./stats_alarm/list": [
		1940,
		128
	],
	"./stats_custom_metric/list": [
		1941,
		131
	],
	"./stats_report/list": [
		1942,
		134
	],
	"./stats_widget/list": [
		1943,
		137
	],
	"./superadmin_profile/list": [
		1944,
		140
	],
	"./tag/list": [
		1945,
		143
	],
	"./tariff/list": [
		1946,
		146
	],
	"./tariff_parent/list": [
		1947,
		149
	],
	"./team/list": [
		1948,
		152
	],
	"./text_message_source/list": [
		1949,
		10
	],
	"./time_interval/list": [
		1950,
		156
	],
	"./user/list": [
		1951,
		159
	],
	"./voice_asterisk/list": [
		1952,
		162
	],
	"./voice_asterisk_downgrade/list": [
		1953,
		165
	],
	"./voice_recording_transcript_setting/list": [
		1954,
		169
	],
	"./voice_route/list": [
		1955,
		172
	],
	"./voice_shortcut/list": [
		1956,
		175
	],
	"./voice_trunk/list": [
		1957,
		178
	],
	"./voice_voicemail/list": [
		1958,
		181
	],
	"./wallboard/list": [
		1959,
		184
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1883;
module.exports = webpackAsyncContext;